import { ArrowIcon } from "assets/icons";
import cn from "classnames";
import { useBoolean } from "hooks";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { Icon, LineInputRange } from "ui";

import { RangeFilterFieldProps } from "../TableFilter.types";

import styles from "../TableFilter.module.scss";

export const RangeFilterField = ({
  title,
  fromFieldKey,
  toFieldKey,
  minTotal,
  maxTotal,
  withAccordion = false
}: RangeFilterFieldProps) => {
  const { value: isOpen, toggle: toggleOpen } = useBoolean(!withAccordion);
  const { watch, setValue } = useFormContext<Record<string, string | number>>();
  const totalFrom = watch(fromFieldKey);
  const totalTo = watch(toFieldKey);

  const totalRangeValues = useMemo(() => {
    return [totalFrom ? +totalFrom : minTotal, totalTo ? +totalTo : maxTotal];
  }, [totalFrom, totalTo, minTotal, maxTotal]);

  const handleTotalChange = (values: number[]) => {
    if (values?.[0] != null) setValue(fromFieldKey, values[0]);
    if (values?.[1] != null) setValue(toFieldKey, values[1]);
  };

  return (
    <div className={styles.filterField}>
      <div
        className={cn(styles.filterField_header, {
          [styles.filterField_header__accordion]: withAccordion
        })}
        onClick={() => {
          if (withAccordion) {
            toggleOpen();
          }
        }}
      >
        <h4 className={styles.filterField_title}>{title}</h4>

        {withAccordion && (
          <Icon
            as={ArrowIcon}
            width={24}
            height={24}
            className={cn(styles.filterField_arrowIcon, {
              [styles.filterField_arrowIcon__open]: isOpen
            })}
          />
        )}
      </div>

      {isOpen && (
        <div className={styles.filterField_box}>
          <LineInputRange
            values={totalRangeValues}
            min={minTotal}
            max={maxTotal > minTotal ? maxTotal : minTotal + 1}
            onChange={handleTotalChange}
            withInputs
          />
        </div>
      )}
    </div>
  );
};
